export default [
  {
    key: "increasement",
    sortable: true,
    sortField: "createdAt",
    label: "#",
    thClass: "w-50px",
  },
  {
    key: "employee",
    sortable: false,
    label: "breadcrumb.employee",
    stickyColumn: true,
    variant: "light",
  },
  {
    key: "date",
    label: "field.date",
  },
  {
    key: "remark",
    label: "field.remark",
  },
  {
    key: "actions",
    label: "general.action",
  },
];
